import React, { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";

import axios from "axios";

import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  onChangeCheckExtensionInstalled,
  setShowErrorModal,
} from "../store/slices/preferenceSlice";

import { getUrl } from "../helpers/url";

import { useCmsHook } from "../helpers/cmsHook";
import CmsEditAndSave from "../helpers/CmsEditAndSave";
import { CmsConstructor } from "../helpers/cmsConstructor";

import { fetchStatus } from "../store/slices/preferenceSlice";

const CheckExtension = () => {
  const { cmsInstance, setCmsInstance } = useCmsHook();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();

  const { tenantId } = useSelector((state) => state.preference);

  useEffect(() => {
    const shop = searchParams.get("shop");
    if (shop) {
      dispatch(fetchStatus({ shop }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (tenantId) {
      extensionInstalledCheck({ dispatch, searchParams, setLoading, tenantId });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantId]);

  useEffect(() => {
    if (window.location.pathname === "/check-extension") {
      const cmsInstance = async () => {
        const cmsObj = await CmsConstructor(dispatch);
        setCmsInstance(cmsObj);
      };
      cmsInstance();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {window.location.pathname === "/check-extension" && (
        <div className="mt-4 d-flex justify-content-center">
          <CmsEditAndSave />
        </div>
      )}
      <div
        className="extension-check-container w-100 my-5"
        style={{ minHeight: "100vh" }}
      >
        <div className="d-flex flex-column justify-content-center align-items-center w-100">
          <div className="w-50 p-4 extensions-content-container">
            {!cmsInstance || loading ? (
              <div className="d-flex flex-row justify-content-center align-items-center">
                <Spinner
                  animation="border"
                  variant="secondary"
                  role="status"
                  size="md"
                ></Spinner>
              </div>
            ) : (
              <>
                {cmsInstance &&
                  cmsInstance.showRichText("cmsContent.checkExtension.text")}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default CheckExtension;

export const extensionInstalledCheck = async ({
  dispatch,
  searchParams,
  setLoading,
  tenantId,
}) => {
  try {
    setLoading(true);
    const shop = searchParams.get("shop");
    const { data: res } = await axios.get(getUrl("REACT_APP_CHECK_EXTENSION"), {
      params: {
        tenantId,
        shop,
      },
    });
    if (res.extensionInstalled) {
      dispatch(
        onChangeCheckExtensionInstalled({ connected: res.extensionInstalled })
      );
    }
  } catch (error) {
    console.log(error.message);
    let errorMessage;
    if (error?.response && error.response?.data?.message)
      errorMessage = error.response.data.message;
    else errorMessage = error.message;
    dispatch(setShowErrorModal({ message: errorMessage }));
  } finally {
    setLoading(false);
  }
};
